export default "__VITE_ASSET__BMXAZWl1__"